module.exports = __webpack_public_path__ + "img/elementlengths_jasp.cd8a09e6.png";